import { Icon } from "@/components/icons";
import { Button } from "@/components/button";
import { MonitoringHeader } from "./monitoring-header";

type Props = {
  onNewMonitoring: () => void;
  onUploadBatch: () => void;
  onDownloadReport: () => void;
  canManageEntries?: boolean;
};

export function EmptyState({
  onNewMonitoring,
  onUploadBatch,
  onDownloadReport,
  canManageEntries = true,
}: Props) {
  return (
    <div className="flex min-h-screen flex-1 flex-col bg-grey-25 px-4 py-4 sm:px-8">
      <MonitoringHeader
        dim
        showUploadBatch
        showDownloadReport
        canManageEntries={canManageEntries}
        onNewMonitoring={onNewMonitoring}
        onUploadBatch={onUploadBatch}
        onDownloadReport={onDownloadReport}
      />
      <Body
        onNewMonitoring={onNewMonitoring}
        onUploadBatch={onUploadBatch}
        canManageEntries={canManageEntries}
      />
    </div>
  );
}

type BodyProps = Omit<Props, "onDownloadReport">;

function Body({ onNewMonitoring, onUploadBatch, canManageEntries = true }: BodyProps) {
  return (
    <div className="flex flex-1 flex-col items-center gap-4 pb-8 pt-20 sm:pt-[160px]">
      <div className="flex w-[160px] flex-col gap-1.5" aria-hidden>
        <div className="h-4 rounded-[4px] bg-grey-200" />
        <div className="h-4 rounded-[4px] bg-grey-200" />
        <div className="h-4 rounded-[4px] bg-grey-200" />
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <h2 className="text-h4 font-semibold text-black">No monitoring entries yet</h2>
        <p className="w-[168px] text-center text-small text-grey-900">
          {canManageEntries
            ? "Start tracking a subject to see them here."
            : "Nothing is being monitored yet."}
        </p>
      </div>
      {canManageEntries && (
        <div className="flex w-[200px] flex-col items-stretch gap-1.5">
          <Button
            hierarchy="tertiary"
            size="sm"
            fullWidth
            leftIcon={<Icon name="add" size={20} weight={300} />}
            onClick={onNewMonitoring}
          >
            Add entry
          </Button>
          <span className="text-center text-small text-grey-500">or</span>
          <Button
            hierarchy="secondary"
            size="sm"
            fullWidth
            leftIcon={<Icon name="publish" size={20} weight={300} />}
            onClick={onUploadBatch}
          >
            Upload batch file
          </Button>
        </div>
      )}
    </div>
  );
}
